/* eslint-disable no-undef */
import { IApps } from "types/applications.type";
import api from "./ApiService";

const getApps = (data: any) => {
  return api
    .get<IApps>(process.env.REACT_APP_API_BASE_URL + `/applications?${data}`)
    .then((response: any) => {
      return response;
    });
};

const AppsService = {
  getApps,
};
export default AppsService;
